<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">彩信</a></li>
                <li><a href="#">彩信详情</a></li>
            </ul>
        </div>
    
        <div class="formbody"> 
            <div id="usual1" class="usual">
                <div id="tab1" class="tabson">        
                    <div class="formtitle"><span>彩信详情</span></div>    
                    <ul class="forminfo">
                        <li><label>彩信名称/标题</label>
                            <input name="" type="text" :disabled="disabled" v-model="title" class="dfinput" /><i>最长30字，建议15字内并加企业签名</i>
                        </li>
                        <li><label>接收人</label><textarea name="" :disabled="disabled" v-model="mobile" cols="" rows="" class="textinput left"></textarea>
                            <i>限500个以内号码，号码间需以逗号“，”相隔</i>
                        </li>
                        

                        <li v-for="(item,index) in mmsInfoList"><label>彩信自助编辑</label>
                            <div class="left" >
                                <dd style="text-align: center; color: #f60;">第{{index+1}}帧</dd>
                                <dd class=" mms_a">
                                    <ol v-if="item.contentPic==''"><img width="200" height="200" src="../../assets/images/200.jpg"  title="彩信图片"></ol>
                                    <ol v-else><img width="200" height="200" :src="item.contentPic"  title="彩信图片"></ol>
                                    <!-- <img v-if="item.contentPic==''"><img width="200" height="200" :src="item.contentPic"  title="彩信图片"> -->
                                    
                                </dd>
                            </div>
                            <div class="left mms_b"> 
                                <dd  class="mms_c">
                                    <span class="left click maringht10">本帧播放时间</span>
                                    <div class="cityleft">
                                        <el-select :disabled="disabled" v-model="item.delay">
                                            <el-option
                                                v-for="item in delayList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </dd>
                                <dd class="mms_c">
                                    <span class="left maringht10">插入图片</span>
                                    <div class="click maringht10" style="float: left;">
                                        
                                    </div> 
                                    <div v-if="item.picDel" class="buttonupload click1 maringht10" @click="delPic(item.frameNum)">删除</div>
                                    <span class="left">建议图片175*144像素，支持格式jpg,gif</span>
                                </dd>
                                <dd class="mms_c">
                                    <span class="left maringht10">文本插入</span>
                                    <span class="left">每帧文字暂限500字（含标点空格）</span>
                                </dd>
                                <dd class="mms_c">
                                    <span class="left ">文字展示：</span><span class="left">{{item.contentTxt}}</span>
                                </dd>

                            </div>
                        </li>

                        <li><label> &nbsp; </label>
                            <!-- <div class="buttonupload click4 maringht10"> 点击查看效果</div>  -->
                            <div class="toolbars lh33">您现在的彩信总大小为:<b>{{allSize}}K</b>，最多5帧，需小于80K </div>
                        </li>

                        <li><label>通道</label>
                            <div class="vocation">
                                <el-select :disabled="disabled" v-model="sendMethod" style="width:600px;">
                                    <el-option  key="10" value="10" label="通道10.显示1069,0.15元/条,三网106彩信产品,只能发手机报,行业,商超会员营销信息"></el-option>
                                </el-select>
                            </div><i  class="toolbars lh33">(温馨提醒：短信末尾均需添加签名;夜间请勿发送太晚，引起投诉） </i>
                        </li>
                    </ul>  

                    <div class="jian">&nbsp;</div>
                    <div class="welinfo">
                        <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                        <b>二办彩信说明</b>
                    </div>
    
                    <ul class="infolist">
                        <li><span>彩信的英文名是MMS，它是Multimedia Messaging Service的缩写，意为多媒体信息服务，通常又称为彩信。</span></li> 
                        <li><span>优点：</span></li> 
                        <li><span>图文并茂:彩信配有丰富的彩色图片、声音、动画、震动等多媒体的内容，图文并茂，生动直观。时尚新颖，客户新鲜感强。</span></li>
                        <li><span>大容量：容量为80K的彩信，相当于8幅精美图片或2万多个汉字，这是原本只有70个汉字的普通短信无法比拟的，全面传达企业形象和销售信息，有助于商家从纷繁喧嚣的传播环境中脱颖而出。</span></li>
                        <li><span>自由，直投：彩信广告的发布时间可以自由控制,不受传统广告制作、发行周期的影响，直接投放。</span></li>
                        <li><span>再营销：制作精美的彩信广告用户更是会保存甚至转发给相关有需要的亲朋好友查阅，能起到长远的效益。</span></li>
                        <li><span>多媒体彩信手机越来越普及，是发送产品介绍、祝福、资讯的好帮手</span></li>
                        <li><span>注意：</span></li>
                        <li><span>1、彩信总体积不要超过80K，否则有些手机可能不能正常接收。</span></li>
                        <li><span>2、制作:彩信以“帧”为页面单位，每帧可以放置一张图片和对应文字信息。</span></li>
                        <li><span>图片格式：jpg、gif；广告图片尺寸：176*144像素（推荐）;动态gif图最好不要超过2张;音频格式：MIDI； 全文字可以发送2万多字。</span></li>
                        <li><span>建议事先备好脚本及素材，支持在线自助编辑,只需按指导上传素材即可(类似做PPT)。代制作费用 80元/个; 动画另计</span></li>
                        <li><span>3、收费:0.18-0.2元/条。发送按提交收费。小部分老款手机因不支持彩信或网络问题，将可能收不到您发送的彩信,费用恕不退还</span></li>
                    </ul>
    
                </div> 
	        </div> 
        </div>
    </div>
   
</template>
<script>
import cookie from '@/components/cookie.vue'
import defaultMmsPic from '../../assets/images/200.jpg'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            id:0,
            mmsInfoList:[],
            mmsid:'',
            allSize:0,
            contentTxt:'',
            title:'',
            mobile:'',
            formart:'phone',
            txtpath:'',
            sendMethod:'10',
            delayList:[
                {value:1000,label:'1秒'},{value:3000,label:'3秒'},{value:5000,label:'5秒'},
                {value:10000,label:'10秒'},{value:30000,label:'30秒'},{value:60000,label:'1分钟'}
            ],
            disabled:true,
        }
    },
    mounted(){
        this.id = this.$route.query.id;
        this.getDate();
    },
    methods:{
        getDate(){
            let that = this;
            let data = {'id':this.id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mms/mmscheckinfo.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.title = res.data.mmsSubject;
                    that.mobile = res.data.mobile;
                    that.mmsInfoList = res.data.mmsProcessList;
                    that.allSize = res.data.allSize;
                    that.txtpath = res.data.txtpath;
                    that.formart = res.data.formart;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        
    }
}
</script>



// WEBPACK FOOTER //
// src/components/mms/mmscheckinfo.vue